import { useState } from "react";
import { useFeatures } from "../hooks/useFeatures";
import styles from './keyInfro.module.css';
import globalStyles from '../result.module.css';

interface Props {
    allowedFeatures: any,
    features: [],
    title: string | null
}

type featuresType = {
    title: string,
    value: string | number
}

const InfomationSection = ({ features, allowedFeatures, title }: Props) => {
    const keyInfo: featuresType[] = useFeatures(allowedFeatures, features);
    const [showMore, setShowMore] = useState(false);
    if (keyInfo && keyInfo.length == 0) return null;
   

    let moreCount = keyInfo.length - 3;

    if (keyInfo.length == 0) return null;
    return <div className={styles.sectionWrapper}>
        {title && <h2 className={globalStyles.subTitleText}>{title}</h2>}
        <div className={styles.gridContainer}>
            {keyInfo.slice(0, !showMore ? 3 : undefined).map((row, i) => {
                return <div className={styles.gridRow} key={i}>
                    <div className={styles.gridCell}><h3 className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{row.title}</h3></div>
                    <div className={styles.gridCell}><p className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`}>{row.value}</p></div>
                </div>
            })}
        </div>
        {keyInfo.length > 3 && <div className={styles.viewMore} onClick={() => setShowMore(!showMore)}>
            <div className={`${globalStyles.smallText} ${globalStyles.lightColorText}`} >{showMore ? 'Show Less' : `View More (${moreCount})`}</div>
        </div>}
    </div>

};

export default InfomationSection;
